export const ALL_ITEMS_GROUP_ID = 'All';

export const ADDED_ITEMS_GROUP_ID = 'ADDED';

export const PROFORMA_BLANK_FORM_TEMPLATE = 'PROFORMA_BLANK_FORM_TEMPLATE';
